import IconButton from '@zenbusiness/zui/IconButton';
import { styled } from '@zenbusiness/zui/styles';
import PropTypes from 'prop-types';

import { IconButtonStyle } from './styles';

const IconButtonStyled = styled(IconButton)(IconButtonStyle);
export default function IconWithHover({ children, sx, ...delegate }) {
  return (
    <IconButtonStyled
      {...delegate}
      sx={{
        width: '32px',
        height: '32px',
        ...sx
      }}
    >
      {children}
    </IconButtonStyled>
  );
}

IconWithHover.propTypes = {
  sx: PropTypes.shape({})
};
